import React, { FC, useState } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { useAuthenticatedMutation } from "components/Auth/AuthenticatedQueryProvider";
import { Button } from "../../modules/ui-kit-react/lib";
import SlackReminderInlineAdd from "./SlackReminderInlineAdd";
import { EnvironmentWithSlack } from "components/EnvForm";
import { useUserRole } from "hooks/useRoleCheck";

import style from "../SlackAlerts/style.module.css";

interface Props {
  environment: EnvironmentWithSlack;
}

const SlackReminders: FC<Props> = ({ environment }) => {
  const [formActive, setFormActive] = useState(false);
  const queryClient = useQueryClient();

  const isUser = useUserRole();

  const deleteReminder = useAuthenticatedMutation<void, { id: number }>(
    "slack-reminders/{reminderId}",
    {
      requiresTenant: true,
      method: "DELETE",
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: [`environments/${environment.id}`],
        });
      },
    }
  );

  const reminders = environment.slackReminders || [];

  return (
    <>
      <h4>Slack Reminders</h4>

      {reminders.map((reminder) => (
        <div className={style.alert} key={reminder.id}>
          <div className={style.alertChannel}>
            <div className={style.alertChannelName}>
              <i className="material-icons">alarm</i>
              <span>{reminder.channel}</span>
            </div>

            {isUser && (
              <div className={style.actions}>
                <Button
                  appearance="danger"
                  small
                  flat
                  icon="delete"
                  onClick={() => deleteReminder.mutate({ id: reminder.id })}
                />
              </div>
            )}
          </div>
        </div>
      ))}

      {formActive ? (
        <SlackReminderInlineAdd
          environmentId={environment.id}
          onClose={() => setFormActive(false)}
        />
      ) : isUser ? (
        <div onClick={() => setFormActive(true)} className={style.add}>
          <i className="material-icons">add</i>
          <span data-cy="add-channel-btn">Add Channel</span>
        </div>
      ) : null}
    </>
  );
};

export default SlackReminders;
